import React, { useEffect, useState, useMemo, useRef } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { apiurl } from "../config/config";
import confetti from "canvas-confetti";
import { MANAGER_META, FLOOR_HEADS, FLOOR_MANAGERS } from "../json/salesTarget";
import gsap from "gsap";

const CAMPAIGN_CONFIG = {
  startDate: "2026-04-01",
  targets: {
    GMIT: 32100, // Rahul
    ALTF: 66000, // Anand
  },
};

// const CAMPAIGN_CONFIG = {
//   startDate: "2026-03-01",
//   targets: {
//     GMIT: 28500, // Rahul
//     ALTF: 46000, // Anand
//   },
// };

const MANAGER_VIDEO_BATTLES = [
  {
    A: "JayVijay5099",
    B: "SanjayRewani1619",
    videos: {
      A: "/videos/JayWon.mp4",
      B: "/videos/SanjayWon.mp4",
      DRAW: "/videos/draw.mp4",
    },
    names: {
      A: "Jay",
      B: "Sanjay",
    },
  },
];

const getBadge = (pos) => {
  if (pos === 0)
    return {
      text: "🥇 GOLD LEADER",
      color: "bg-yellow-400 text-black",
    };

  if (pos === 1)
    return {
      text: "🥈 SILVER",
      color: "bg-slate-300 text-black",
    };

  if (pos === 2)
    return {
      text: "🥉 BRONZE",
      color: "bg-orange-400 text-black",
    };

  return {
    text: "⭐ TOP PERFORMER",
    color: "bg-indigo-600 text-white",
  };
};

// const MANAGER_BATTLES = [
//   { A: "Abhishek4629", B: "SanjayRewani1619" },
//   { A: "Himanshu1203", B: "Sharvan242" },
//   // { A: "Himanshu1203", B: "ASHWANI3434" },
// ];

const floorWinnerByPercentage = (aValue, aTarget, bValue, bTarget) => {
  const aPct = (aValue / aTarget) * 100;
  const bPct = (bValue / bTarget) * 100;

  const diff = Math.abs(aPct - bPct);

  // treat as draw if difference < 0.5%
  if (diff < 0.5) return "DRAW";

  return aPct > bPct ? "A" : "B";
};
/* ================= UTILS ================= */

const winnerOf = (a, b) => (a === b ? "DRAW" : a > b ? "A" : "B");

const getProgressMeta = (p) => {
  if (p >= 100) return { color: "#16a34a", text: "TARGET ACHIEVED" };
  if (p >= 90) return { color: "#22c55e", text: "EXCELLENT" };
  if (p >= 80) return { color: "#4ade80", text: "VERY GOOD" };
  if (p >= 70) return { color: "#a3e635", text: "ON TRACK" };
  if (p >= 60) return { color: "#facc15", text: "NEEDS PUSH" };
  if (p >= 50) return { color: "#fbbf24", text: "NEEDS PUSH" };
  if (p >= 40) return { color: "#fb923c", text: "CRITICAL PUSH" };
  if (p >= 30) return { color: "#f97316", text: "CRITICAL PUSH" };
  if (p >= 20) return { color: "#ef4444", text: "ALERT" };
  return { color: "#dc2626", text: "HIGH ALERT" };
};

const getBattleCommentary = (A, B, aVal, bVal) => {
  if (aVal === bVal)
    return {
      headline: "It's a Perfect Draw 🤝",
      sub: "Anyone can take the lead with 1 order!",
    };
  const leaderId = aVal > bVal ? A : B;
  const trailerId = aVal > bVal ? B : A;
  const diff = Math.abs(aVal - bVal);
  return {
    headline: `${MANAGER_META[leaderId].name} is leading by +${diff} orders`,
    sub: `${MANAGER_META[trailerId].name} needs ${diff + 1} more orders to WIN 🏆`,
  };
};

/* ================= SCALE HOOK ================= */

function useTVScale() {
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const updateScale = () => setScale(window.innerWidth / 1920);
    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);
  return scale;
}

const managerWinnerByPercentage = (managers) => {
  const enriched = managers.map((m) => {
    const target = MANAGER_META[m.id].target;
    const pct = target > 0 ? (m.value / target) * 100 : 0;
    return { ...m, pct };
  });

  const sorted = [...enriched].sort((a, b) => b.pct - a.pct);

  const leader = sorted[0];
  const runnerUp = sorted[1];

  // tolerance for real draw (0.5%)
  const isDraw = runnerUp && Math.abs(leader.pct - runnerUp.pct) < 0.5;

  if (isDraw) {
    return enriched.map((m) => ({ ...m, status: "DRAW" }));
  }

  return enriched.map((m) => ({
    ...m,
    status: m.id === leader.id ? "WIN" : "LOSE",
  }));
};

export default function WideScreen() {
  const [showWinnerVideo, setShowWinnerVideo] = useState(false);
  const [winnerFloor, setWinnerFloor] = useState(null);

  const [showManagerVideo, setShowManagerVideo] = useState(false);
  const [managerWinner, setManagerWinner] = useState(null);

  const [campaignData, setCampaignData] = useState({});
  const [managerLoginData, setManagerLoginData] = useState([]);

  const scale = useTVScale();
  const [managerOrders, setManagerOrders] = useState({});
  const [managersDetails, setManagersDetails] = useState([]);
  const [slideType, setSlideType] = useState("INTRO");
  //   const [battleIndex, setBattleIndex] = useState(0);
  //   const [floorIndex, setFloorIndex] = useState(0);
  const [groupIndex, setGroupIndex] = useState(0);

  const fetchManagerLoginSummary = async () => {
    try {
      const res = await axios.get(
        `${apiurl}/utils/crm/getManagerAgentSummary`, // your backend route
      );

      if (res.data?.success) {
        setManagerLoginData(res.data.data.data || []);
        console.log("Manager Login Summary:", res.data.data);
      }
    } catch (err) {
      console.error("Login Summary Error:", err);
    }
  };

  useEffect(() => {
    fetchManagerLoginSummary(); // initial call

    const interval = setInterval(
      () => {
        fetchManagerLoginSummary();
      },
      60 * 10 * 1000,
    ); // every 10 minutes

    return () => clearInterval(interval);
  }, []);

  const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

  const [teamData, setTeamData] = useState([]);

  const fetchPerformance = async () => {
    try {
      const baseParams = {
        from_date: today,
        to_date: today,
        agent_ids: "",
        manager_ids: "",
      };

      const [dcRes, ppRes] = await Promise.all([
        axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
          params: { ...baseParams, tl_ids: "Superdc" },
        }),
        axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
          params: { ...baseParams, tl_ids: "Super_Paachan_Pro" },
        }),
      ]);

      const dcOrders = dcRes?.data?.data?.result?.data?.total?.totalOrders || 0;

      const ppOrders = ppRes?.data?.data?.result?.data?.total?.totalOrders || 0;

    const teams = [
      {
        team_name: "SUPER_DC_TEAM",
        orders: dcOrders,
        target: 350,
        image: "/images/superDCTeam.png"
      },
      {
        team_name: "SUPER_PP_TEAM",
        orders: ppOrders,
        target: 300,
        image: "/images/superPPTeam.png"
      }
    ];

      setTeamData(teams);
    } catch (error) {
      console.error("Team API Error:", error);
    }
  };
  useEffect(() => {
    fetchPerformance();

    const interval = setInterval(fetchPerformance, 50000);

    return () => clearInterval(interval);
  }, []);

  const managerLoginMap = useMemo(() => {
    const map = {};
    managerLoginData.forEach((m) => {
      map[m.user_name] = m; // ✅ MUST MATCH m.id
    });
    return map;
  }, [managerLoginData]);

  const managerDetailsMap = useMemo(() => {
    const map = {};
    managersDetails.forEach((m) => {
      map[m.o_manager_name] = m; // ✅ IMPORTANT
    });
    return map;
  }, [managersDetails]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ===== DATES =====
        const today = new Date().toISOString().split("T")[0];
        const campaignStart = CAMPAIGN_CONFIG.startDate;

        // ===== PARALLEL API CALLS (FAST) =====
        const [dailyRes, campaignRes] = await Promise.all([
          axios.get(`${apiurl}/utils/crm/realTimeOrderData2`, {
            headers: { token: "ad2355a9d54335e27e2c3a3ed5b6e381" },
            params: {
              from_date: today,
              to_date: today,
            },
          }),

          axios.get(`${apiurl}/utils/crm/realTimeOrderData2`, {
            headers: { token: "ad2355a9d54335e27e2c3a3ed5b6e381" },
            params: {
              from_date: campaignStart,
              to_date: today,
            },
          }),
        ]);

        /* ===== DAILY DATA ===== */
        const dailyList = dailyRes?.data?.data?.result?.data?.managers || [];

        setManagersDetails(dailyList);

        const dailyMap = {};
        dailyList.forEach((m) => {
          dailyMap[m.o_manager_name] = Number(m.totalOrders || 0);
        });

        setManagerOrders(dailyMap);

        /* ===== CAMPAIGN DATA ===== */
        const campaignList =
          campaignRes?.data?.data?.result?.data?.managers || [];

        const campaignMap = {};

        campaignList.forEach((m) => {
          campaignMap[m.o_manager_name] = Number(m.totalOrders || 0);
        });

        setCampaignData(campaignMap);

        console.log("Campaign params:", {
          from_date: campaignStart,
          to_date: today,
        });
      } catch (err) {
        console.error("Fetch error:", err);
      }
    };

    // first load
    fetchData();

    // auto refresh
    const api = setInterval(fetchData, 30000);

    return () => clearInterval(api);
  }, []);

  /* ---------- FLOOR DATA ---------- */
  const floorData = useMemo(() => {
    const sum = (arr) => arr.reduce((a, b) => a + (managerOrders[b] || 0), 0);
    return { GMIT: sum(FLOOR_MANAGERS.GMIT), ALTF: sum(FLOOR_MANAGERS.ALTF) };
  }, [managerOrders]);

  const campaignFloorData = useMemo(() => {
    const sum = (arr) => arr.reduce((a, b) => a + (campaignData[b] || 0), 0);

    return {
      GMIT: sum(FLOOR_MANAGERS.GMIT),
      ALTF: sum(FLOOR_MANAGERS.ALTF),
    };
  }, [campaignData]);

  const MANAGER_GROUPS = [
    ["SanjayRewani1619", "JayVijay5099"],
    ["Himanshu1203", "LavitBhati714"],
    // ["Himanshu1203", "ASHWANI3434"],
    // ["Abhishek4629", "LavitBhati714"],
  ];
  // const MANAGER_GROUPS = [
  //   ["SanjayRewani1619", "JayVijay5099"],
  //   ["Himanshu1203", "Sharvan242"],
  //   // ["Himanshu1203", "ASHWANI3434"],
  //   ["Abhishek4629", "LavitBhati714"],
  // ];

  const duration = slideType === "CAMPAIGN" ? 15000 : 10000;


  useEffect(() => {
    if (showWinnerVideo) return;

    const timer = setTimeout(() => {
      if (slideType === "INTRO") {
        setSlideType("FLOOR");
      } else if (slideType === "FLOOR") {
        setSlideType("MANAGER");
        setGroupIndex(0);
      } else if (slideType === "MANAGER") {
        if (groupIndex + 1 < MANAGER_GROUPS.length) {
          setGroupIndex((g) => g + 1);
        } else {
          setGroupIndex(0);
          setSlideType("CAMPAIGN");
        }
      } else if (slideType === "CAMPAIGN") {
        setSlideType("TEAMWISE");
      // } else if (slideType === "TEAMWISE") {
      } else if (slideType === "TEAMWISE") {
  setSlideType("REVENUE");
} else if (slideType === "REVENUE") {

        setSlideType("FLOOR");
      }
    }, duration);

    return () => clearTimeout(timer);
  }, [slideType, groupIndex, showWinnerVideo]);

  const currentGroup =
    slideType === "MANAGER" ? MANAGER_GROUPS[groupIndex] : null;

  const managerGroupData = useMemo(() => {
    if (!currentGroup) return [];

    const baseData = currentGroup.map((id) => ({
      id,
      value: managerOrders[id] || 0,
    }));

    return managerWinnerByPercentage(baseData);
  }, [currentGroup, managerOrders]);

  const floorAgentStats = useMemo(() => {
    const calculateFloorStats = (managerIds) => {
      let totalAgents = 0;
      let loginAgents = 0;
      let below3Orders = 0;

      managerIds.forEach((id) => {
        const login = managerLoginMap[id];
        const details = managerDetailsMap[id];

        if (login) {
          totalAgents += Number(login.total_agents || 0);
          loginAgents += Number(login.today_login_count || 0);
        }

        if (details) {
          below3Orders += Number(details.agent_count_below_5 || 0);
        }
      });

      const shrinkage =
        totalAgents > 0 ? ((totalAgents - loginAgents) / totalAgents) * 100 : 0;

      return {
        totalAgents,
        loginAgents,
        shrinkage,
        below3Orders,
      };
    };

    return {
      GMIT: calculateFloorStats(FLOOR_MANAGERS.GMIT),
      ALTF: calculateFloorStats(FLOOR_MANAGERS.ALTF),
    };
  }, [managerLoginMap, managerDetailsMap]);

  const managerOrdersRef = useRef({});

  useEffect(() => {
    managerOrdersRef.current = managerOrders;
  }, [managerOrders]);

  const detectFloorWinner = (data) => {
    const win = floorWinnerByPercentage(
      data.GMIT,
      FLOOR_HEADS[0].target,
      data.ALTF,
      FLOOR_HEADS[1].target,
    );

    if (win === "A") setWinnerFloor("GMIT");
    else if (win === "B") setWinnerFloor("ALTF");
    else setWinnerFloor("DRAW");
  };

  const detectManagerWinner = (orders) => {
    const battle = MANAGER_VIDEO_BATTLES[0];

    const aValue = orders[battle.A] || 0;
    const bValue = orders[battle.B] || 0;

    const win = winnerOf(aValue, bValue);

    if (win === "A") setManagerWinner({ id: "A", battle });
    else if (win === "B") setManagerWinner({ id: "B", battle });
    else setManagerWinner({ id: "DRAW", battle });
  };

  // useEffect(() => {
  //   const playManagerVideo = () => {
  //     const latestOrders = managerOrdersRef.current;

  //     if (!latestOrders) return;

  //     detectManagerWinner(latestOrders);

  //     setShowManagerVideo(true);

  //     setTimeout(() => {
  //       setShowManagerVideo(false);
  //     }, 10000);
  //   };

  //   const interval = setInterval(playManagerVideo, 2700000);
  //   // const interval = setInterval(playManagerVideo, 90000);

  //   return () => clearInterval(interval);
  // }, []);

  // const floorDataRef = useRef([]);

  // useEffect(() => {
  //   floorDataRef.current = floorData;
  // }, [floorData]);

  // useEffect(() => {
  //   const playWinnerVideo = () => {
  //     const latestData = floorDataRef.current;

  //     // if (!latestData || latestData.length === 0) return;
  //     if (!latestData.GMIT && !latestData.ALTF) return;

  //     detectFloorWinner(latestData);

  //     setShowWinnerVideo(true);

  //     setTimeout(() => {
  //       setShowWinnerVideo(false);
  //     }, 10000);
  //   };

  //   const interval = setInterval(playWinnerVideo, 1800000);
  //   // const interval = setInterval(playWinnerVideo, 60000);

  //   return () => clearInterval(interval);
  // }, []);





  const [revenueData, setRevenueData] = useState(null);



  const fetchMonthlyRevenue = async () => {
  try {
    const res = await axios.get(
      `${apiurl}/utils/crm/getMonthlyOrderAnalytics`,
      {
        params: {
          startDate: "2026-04-01",
          endDate: "2026-04-30",
        },
      }
    );

    if (res.data?.success) {
      setRevenueData(res.data);
      console.log("Revenue Data Loaded");
    }
  } catch (err) {
    console.error("Revenue API Error:", err);
  }
};



useEffect(() => {
  fetchMonthlyRevenue(); // first load

  const interval = setInterval(fetchMonthlyRevenue, 60 * 60 * 1000); // ⏱️ 1 hour

  return () => clearInterval(interval);
}, []);


const floorRevenue = useMemo(() => {
  if (!revenueData?.managerStats) return null;

  const result = {
    GMIT: { net: 0, partial: 0 },
    ALTF: { net: 0, partial: 0 },
  };

  Object.entries(revenueData.managerStats).forEach(
    ([manager, managerData]) => {

      // 👉 Find floor
      let floor = null;

      if (FLOOR_MANAGERS.GMIT.includes(manager)) {
        floor = "GMIT";
      } else if (FLOOR_MANAGERS.ALTF.includes(manager)) {
        floor = "ALTF";
      } else {
        return; // skip if not mapped
      }

      // 👉 Add only NON-CANCELLED
      Object.entries(managerData.statusStats || {}).forEach(
        ([status, val]) => {
          if (status === "Cancelled") return;

          result[floor].net += val.net || 0;
          result[floor].partial += val.partial || 0;
        }
      );
    }
  );

  return result;
}, [revenueData]);

const revenueInsights = useMemo(() => {
  if (!revenueData?.managerStats) return null;

  let topManager = { name: "", net: 0 };

  let cancelledLoss = 0;
  let totalOrders = 0;
  let totalNet = 0;

  const floor = {
    GMIT: { net: 0, partial: 0 },
    ALTF: { net: 0, partial: 0 },
  };

  Object.entries(revenueData.managerStats).forEach(
    ([manager, managerData]) => {

      let managerNet = 0;

      // floor detect
      let floorKey = null;
      if (FLOOR_MANAGERS.GMIT.includes(manager)) floorKey = "GMIT";
      else if (FLOOR_MANAGERS.ALTF.includes(manager)) floorKey = "ALTF";

      Object.entries(managerData.statusStats || {}).forEach(
        ([status, val]) => {

          if (status === "Cancelled") {
            cancelledLoss += val.net || 0;
            return;
          }

          // add floor revenue
          if (floorKey) {
            floor[floorKey].net += val.net || 0;
            floor[floorKey].partial += val.partial || 0;
          }

          managerNet += val.net || 0;
          totalNet += val.net || 0;
          totalOrders += val.orders || 0;
        }
      );

      // TOP MANAGER
      if (managerNet > topManager.net) {
        topManager = { name: manager, net: managerNet };
      }
    }
  );

  const AOV = totalOrders ? totalNet / totalOrders : 0;

  return {
    floor,
    topManager,
    cancelledLoss,
    AOV,
  };
}, [revenueData]);
  return (
    <div
      style={{
        transform: `scale(${scale})`,
        transformOrigin: "top left",
        width: 1920,
        height: 1080,
      }}
      className="bg-gradient-to-br from-slate-50 via-white to-slate-100 overflow-hidden"
    >
      {/* {showWinnerVideo && winnerFloor && <WinnerVideo winner={winnerFloor} />}

      {showManagerVideo && managerWinner && (
        <ManagerWinnerVideo data={managerWinner} />
      )} */}

      {slideType === "INTRO" && <IntroSlide />}
      {slideType === "CAMPAIGN" && (
        <CampaignSlide floorData={campaignFloorData} />
      )}
      {slideType === "TEAMWISE" && <TeamWiseCard data={teamData} />}

      {/* {slideType === "REVENUE" && floorRevenue && (
  <RevenueSlide data={floorRevenue} />
)} */}


{slideType === "REVENUE" && revenueInsights && (
  <RevenueSlidePro data={revenueInsights} />
)}

      {slideType === "FLOOR" && (
        <FloorSlide floorData={floorData} floorAgentStats={floorAgentStats} />
      )}

      {slideType === "MANAGER" && (
        <ManagerGroupSlide
          managers={managerGroupData}
          managerDetailsMap={managerDetailsMap}
          managerLoginMap={managerLoginMap}
        />
      )}
    </div>
  );
}

/* ================= INTRO SLIDE ================= */

function IntroSlide() {
  return (
    <SlideWrapper>
      <motion.div
        className="text-center mb-16"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <motion.h1
          animate={{ scale: [1, 1.04, 1] }}
          transition={{ repeat: Infinity, duration: 1.6 }}
          className="text-[96px] font-black tracking-tight bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent"
        >
          🚀 Today’s Sales Battle
        </motion.h1>
        <p className="mt-6 text-[40px] font-semibold text-gray-600">
          Live • Competitive • High Energy
        </p>
      </motion.div>

      <div className="grid grid-cols-2 gap-24 mt-10">
        {FLOOR_HEADS.map((f) => (
          <motion.div
            key={f.key}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-white rounded-[36px] p-12 text-center shadow-xl"
          >
            <img
              src={f.photo}
              className="w-64 h-64 mx-auto rounded-full border-4 border-indigo-500"
            />
            <h2 className="text-[52px] font-black mt-6">{f.name}</h2>
            <p className="text-[32px] text-gray-600">
              Target: <b>{f.target}</b>
            </p>
          </motion.div>
        ))}
      </div>
    </SlideWrapper>
  );
}

/* ================= FLOOR SLIDE ================= */

function FloorSlide({ floorData, floorAgentStats }) {
  //   const win = winnerOf(floorData.GMIT, floorData.ALTF);
  const win = floorWinnerByPercentage(
    floorData.GMIT,
    FLOOR_HEADS[0].target,
    floorData.ALTF,
    FLOOR_HEADS[1].target,
  );

  return (
    <SlideWrapper>
      <h1 className="text-6xl font-black text-center mb-10">
        Live Floor Performance
      </h1>
      <div className="grid grid-cols-2 gap-12">
        {FLOOR_HEADS.map((f, i) => (
          <AdvancedFloorCard
            key={f.key}
            floor={f}
            value={i === 0 ? floorData.GMIT : floorData.ALTF}
            achievement={Math.round(
              ((i === 0 ? floorData.GMIT : floorData.ALTF) / f.target) * 100,
            )}
            isWinner={win === (i === 0 ? "A" : "B")}
            isLoser={win === (i === 0 ? "B" : "A")}
            isDraw={win === "DRAW"}
            stats={i === 0 ? floorAgentStats.GMIT : floorAgentStats.ALTF}
          />
        ))}
      </div>
    </SlideWrapper>
  );
}

const SlideWrapper = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center px-5 py-5">
    <AnimatePresence mode="wait">
      <motion.div
        key="slide"
        initial={{ opacity: 0, y: 60, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -60, scale: 0.98 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="w-full rounded-[40px] p-12 bg-white shadow-[0_30px_80px_rgba(0,0,0,0.12)] border border-gray-200 text-gray-900"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  </div>
);

const ManagerCard = ({
  id,
  value,
  status,
  managerData,
  loginData,
  position,
}) => {
  console.log("loginData", loginData);
  const m = MANAGER_META[id];
  const pct = Math.min(100, Math.round((value / m.target) * 100));
  const { color, text } = getProgressMeta(pct);
  const remaining = Math.max(m.target - value, 0);

  console.log("managerData", managerData);
  const badge = getBadge(position);

  const total = loginData?.total_agents || 0;
  const loggedIn = loginData?.today_login_count || 0;

  const loginPercentage = total ? (loggedIn / total) * 100 : 0;

  const notLoginPercentage = 100 - loginPercentage;

  return (
    <motion.div
      animate={status === "WIN" ? { scale: [1, 1.03, 1] } : {}}
      transition={{ repeat: Infinity, duration: 1.4 }}
      className="relative p-8 rounded-3xl border-4 text-center overflow-hidden"
      style={{
        borderColor: color,
        boxShadow:
          status === "WIN"
            ? "0 0 40px rgba(34,197,94,0.6)"
            : "0 0 20px rgba(0,0,0,0.15)",
      }}
    >
      <StatusStrip status={status} />
      <div
        className="mx-auto w-72 h-72 rounded-full p-2 mb-6"
        style={{
          background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
        }}
      >
        <img
          src={m.photo}
          className="w-full h-full rounded-full border-4 mt-3"
          style={{ borderColor: color }}
        />
      </div>
      <h2 className="text-3xl font-black">{m.name}</h2>
      <div className="text-[96px] font-extrabold leading-none">
        <span style={{ color }}>{value}</span>
        <span className="opacity-40 text-[56px]"> / {m.target}</span>
      </div>
      <p className="mt-4 text-[34px] font-semibold text-gray-700">
        {remaining > 0
          ? `${remaining} orders to target`
          : "Target completed 🎉"}
      </p>

      <div className="mt-4 flex justify-center gap-4">
        {loginData && (
          <>
            <div className="bg-gray-50 border rounded-lg p-1 text-center px-2">
              <p className="text-xs text-gray-500 uppercase">Total Agents</p>
              <p className="text-xl font-bold text-gray-500">
                {loginData.total_agents || 0}
              </p>
            </div>
            <div className="bg-green-50 border border-green-900 rounded-lg p-1 px-2 text-center">
              <p className="text-xs text-green-500 uppercase">Login Agents</p>
              <p className="text-xl font-bold text-green-500">
                {loginData.today_login_count || 0}
              </p>
            </div>

            <div className="bg-red-50 border border-red-900 rounded-lg p-1 px-2 text-center">
              <p className="text-xs text-red-500 uppercase">Shrinkage %</p>
              <p className="text-xl font-bold text-red-600">
                {total ? notLoginPercentage.toFixed(1) : 0}%
              </p>
            </div>
          </>
        )}
        {managerData?.agent_count_below_5 !== undefined && (
          <div className="bg-red-50 border border-red-900 rounded-lg p-1 px-2 text-center">
            <p className="text-xs text-red-500 uppercase">
              Agents Below 5 Orders
            </p>
            <p className="text-xl font-bold text-red-900">
              {managerData?.agent_count_below_5 || 0}
            </p>
          </div>
        )}
      </div>
      <div className="h-5 bg-gray-200 rounded-full overflow-hidden mt-4">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 1 }}
          className="h-full rounded-full"
          style={{ backgroundColor: color }}
        />
      </div>
      <div className="mt-4 flex justify-between items-center">
        <p className="text-[30px] font-extrabold" style={{ color }}>
          {pct}% achieved
        </p>
        <p className="text-[30px] font-black tracking-wider" style={{ color }}>
          {text}
        </p>
      </div>
    </motion.div>
  );
};

const StatusStrip = ({ status }) => (
  <div
    className={`absolute top-0 left-0 right-0 py-2 text-white font-bold text-xl rounded-t-3xl ${status === "WIN" ? "bg-green-600" : status === "LOSE" ? "bg-red-600" : "bg-gray-600"}`}
  >
    {status === "WIN"
      ? "🏆 WINNER"
      : status === "LOSE"
        ? "😞 LOSER"
        : "🤝 DRAW"}
  </div>
);

function LiveCommentary({ headline, sub }) {
  return (
    <motion.div
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="mb-10 w-full mx-auto rounded-3xl bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white shadow-[0_0_60px_rgba(99,102,241,0.8)]"
    >
      <div className="px-12 py-6 text-center">
        <motion.h2
          animate={{ scale: [1, 1.04, 1] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
          className="text-5xl font-black tracking-wide"
        >
          {headline}
        </motion.h2>
        <p className="mt-3 text-3xl font-bold text-yellow-300">{sub}</p>
        <motion.span
          animate={{ opacity: [1, 0.4, 1] }}
          transition={{ repeat: Infinity, duration: 1 }}
          className="inline-block mt-4 bg-black/40 px-6 py-2 rounded-full text-xl font-bold"
        >
          🔴 LIVE BATTLE
        </motion.span>
      </div>
    </motion.div>
  );
}

function AdvancedFloorCard({ floor, value, isWinner, isLoser, stats }) {
  const target = floor.target;
  const remaining = Math.max(target - value, 0);
  const pct = Math.min(100, Math.round((value / target) * 100));
  const { color, text } = getProgressMeta(pct);
  const stripStyle = isWinner
    ? "bg-green-600"
    : isLoser
      ? "bg-red-600"
      : "bg-gray-700";
  const stripText = isWinner ? "🏆 WINNER" : isLoser ? "😞 LOSER" : "🤝 DRAW";

  return (
    <motion.div
      animate={{ scale: isWinner ? [1, 1.05, 1] : 1 }}
      transition={{ repeat: isWinner ? Infinity : 0, duration: 1.3 }}
      className="relative rounded-3xl p-10 border-4 bg-white shadow-2xl"
      style={{ borderColor: color }}
    >
      <div
        className={`absolute top-0 left-0 right-0 py-3 text-center text-white font-black text-[32px] rounded-t-3xl ${stripStyle}`}
      >
        {stripText}
      </div>
      <div className="flex flex-col items-center mt-10">
        <img
          src={floor.photo}
          className="w-72 h-72 rounded-full border-4"
          style={{ borderColor: color }}
        />
        <p className="mt-4 text-[52px] font-black tracking-wide">
          {floor.name}
        </p>
      </div>
      <div className="mt-4 text-center">
        <div className="text-[80px] font-extrabold leading-none">
          <span style={{ color }}>{value}</span>
          <span className="opacity-40 text-[56px]"> / {target}</span>
        </div>
        <p className="mt-4 text-[34px] font-semibold text-gray-700">
          {remaining > 0
            ? `${remaining} orders to target`
            : "Target completed 🎉"}
        </p>
      </div>
      <div className="mt-4 flex justify-center gap-4">
        <div className="bg-gray-50 border rounded-lg p-2 text-center px-3">
          <p className="text-xs text-gray-500 uppercase">Total Agents</p>
          <p className="text-2xl font-bold text-gray-700">
            {stats?.totalAgents || 0}
          </p>
        </div>

        <div className="bg-green-50 border border-green-900 rounded-lg p-2 px-3 text-center">
          <p className="text-xs text-green-500 uppercase">Active</p>
          <p className="text-2xl font-bold text-green-600">
            {stats?.loginAgents || 0}
          </p>
        </div>

        <div className="bg-red-50 border border-red-900 rounded-lg p-2 px-3 text-center">
          <p className="text-xs text-red-500 uppercase">Shrinkage</p>
          <p className="text-2xl font-bold text-red-600">
            {stats?.shrinkage?.toFixed(1) || 0}%
          </p>
        </div>

        <div className="bg-orange-50 border border-orange-900 rounded-lg p-2 px-3 text-center">
          <p className="text-xs text-orange-500 uppercase">Below 5 Orders</p>
          <p className="text-2xl font-bold text-orange-600">
            {stats?.below3Orders || 0}
          </p>
        </div>
      </div>
      <div className="mt-6">
        <div className="h-4 bg-gray-200 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${pct}%` }}
            transition={{ duration: 0.8 }}
            className="h-full rounded-full"
            style={{ backgroundColor: color }}
          />
        </div>
        <div className="mt-4 flex justify-between items-center">
          <p className="text-[32px] font-extrabold" style={{ color }}>
            {pct}% achieved
          </p>
          <p
            className="text-[32px] font-black tracking-wider"
            style={{ color }}
          >
            {text}
          </p>
        </div>
      </div>
    </motion.div>
  );
}

function ManagerGroupSlide({ managers, managerDetailsMap, managerLoginMap }) {
  const leader = managers.find((m) => m.status === "WIN");

  //   console.log("managersDetails 1450",managersDetails);
  //   console.log("managersDetails",managers);
  //   const mangerData = managersDetails[leader.id];
  //   console.log("mangerData",mangerData);
  //   console.log("leader",leader);
  return (
    <SlideWrapper>
      {leader && (
        <LiveCommentary
          headline={`🔥 ${MANAGER_META[leader.id].name} is leading`}
          sub={`Target: ${MANAGER_META[leader.id].target} orders`}
        />
      )}

      <div className="grid grid-cols-2 gap-6 mt-10">
        {/* {managers.map((m) => (
          <ManagerCard key={m.id} id={m.id} value={m.value} status={m.status} managerData={managersDetails?.[m.id]} />
        ))} */}
        {managers.map((m, index) => {
          {
            /* const details = managersDetails.find(
            (x) => x.o_manager_name === m.id,
          ); */
          }
          const details = managerDetailsMap[m.id];
          const loginData = managerLoginMap[m.id];

          return (
            <ManagerCard
              key={m.id}
              id={m.id}
              value={m.value}
              status={m.status}
              managerData={details}
              loginData={loginData}
              position={index}
            />
          );
        })}
      </div>
    </SlideWrapper>
  );
}

function CampaignSlide({ floorData }) {
  // ===== WINNER LOGIC =====
  const win = floorWinnerByPercentage(
    floorData.GMIT,
    CAMPAIGN_CONFIG.targets.GMIT,
    floorData.ALTF,
    CAMPAIGN_CONFIG.targets.ALTF,
  );

  const winnerName =
    win === "A"
      ? FLOOR_HEADS[0].name
      : win === "B"
        ? FLOOR_HEADS[1].name
        : "DRAW";

  return (
    <SlideWrapper>
      {/* ===== HEADER ===== */}
      <h1 className="text-6xl font-black text-center mb-6">
        🎯 Campaign Progress
      </h1>

      {/* ===== PREDICTED WINNER ===== */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8 text-center"
      >
        <p className="text-4xl font-black text-indigo-600">
          🔮 Predicted Winner: {winnerName}
        </p>
      </motion.div>

      {/* ===== FLOOR CARDS ===== */}
      <div className="grid grid-cols-2 gap-12">
        {FLOOR_HEADS.map((f, i) => {
          const key = i === 0 ? "GMIT" : "ALTF";
          const target = CAMPAIGN_CONFIG.targets[key];

          const value = i === 0 ? floorData.GMIT : floorData.ALTF;

          const remaining = Math.max(target - value, 0);

          const pct = Math.min(100, Math.round((value / target) * 100));

          const isWinner = win === (i === 0 ? "A" : "B");
          const isLoser = win === (i === 0 ? "B" : "A");

          return (
            <motion.div
              key={f.key}
              animate={{
                scale: isWinner ? [1, 1.04, 1] : 1,
              }}
              transition={{
                repeat: isWinner ? Infinity : 0,
                duration: 1.6,
              }}
              className={`
                relative rounded-3xl p-10 border-4 bg-white shadow-2xl
                ${isWinner ? "border-green-500" : "border-gray-200"}
              `}
            >
              {/* ===== WIN / LOSE STRIP ===== */}
              <div
                className={`
                  absolute top-0 left-0 right-0 py-3 text-center
                  text-white font-black text-2xl rounded-t-3xl
                  ${
                    isWinner
                      ? "bg-green-600"
                      : isLoser
                        ? "bg-red-600"
                        : "bg-gray-600"
                  }
                `}
              >
                {isWinner ? "🏆 LEADING" : isLoser ? "😞 BEHIND" : "🤝 DRAW"}
              </div>

              {/* ===== IMAGE ===== */}
              <div className="flex flex-col items-center mt-12">
                <img
                  src={f.photo}
                  className="w-60 h-60 rounded-full border-4 border-indigo-500"
                />

                <p className="mt-4 text-5xl font-black">{f.name}</p>
              </div>

              {/* ===== VALUES ===== */}
              <div className="mt-6 text-center">
                <div className="text-[80px] font-black text-indigo-600">
                  {value}
                  <span className="text-[40px] opacity-50"> / {target}</span>
                </div>

                <p className="text-3xl font-bold text-red-600 mt-2">
                  Remaining: {remaining}
                </p>
              </div>

              {/* ===== PROGRESS ===== */}
              <div className="mt-6">
                <div className="h-6 bg-gray-200 rounded-full overflow-hidden">
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${pct}%` }}
                    transition={{ duration: 1 }}
                    className="h-full bg-green-600"
                  />
                </div>

                <p className="text-2xl font-black text-green-700 mt-3 text-center">
                  {pct}% Campaign Complete
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>

      {/* ===== FOOTER ===== */}
      <p className="text-center mt-8 text-3xl font-black text-indigo-600">
        🏆 Winner will be announced on 30 April
      </p>
      {/* <p className="text-center mt-8 text-3xl font-black text-indigo-600">
        🏆 Winner will be announced on 31 March
      </p> */}
    </SlideWrapper>
  );
}
function TeamWiseCard({ data }) {
  const winner =
    data?.length > 0
      ? data.reduce((prev, curr) => (prev.orders > curr.orders ? prev : curr))
      : null;

  /* 🎆 Confetti when target achieved */
  useEffect(() => {
    if (winner && winner.orders >= winner.target) {
      confetti({
        particleCount: 300,
        spread: 120,
        origin: { y: 0.6 },
      });
    }
  }, [winner]);

  return (
    <SlideWrapper>
      {/* Arena Background Glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-900 via-purple-900 to-black opacity-20 blur-3xl" />

      <h1 className="text-7xl font-black text-center mb-16 tracking-wide">
        ⚔️ Sales Battle Arena
      </h1>

      <div className="relative grid grid-cols-2 gap-16 items-center">
        {/* VS ORB */}
        {data.length === 2 && (
          <div className="absolute left-1/2 -translate-x-1/2 z-30">
            {/* glow */}
            <div className="absolute inset-0 rounded-full bg-red-500 blur-3xl opacity-60 animate-pulse" />

            {/* spinning ring */}
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ repeat: Infinity, duration: 8, ease: "linear" }}
              className="absolute inset-0 rounded-full border-[6px] border-red-400"
            />

            {/* VS core */}
            <div className="relative w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br from-red-500 to-yellow-400 text-white text-6xl font-black shadow-[0_0_80px_rgba(255,0,0,0.9)]">
              {/* VS */}⚡
            </div>
          </div>
        )}

        {data.map((team) => {
          const pct = team.target
            ? Math.round((team.orders / team.target) * 100)
            : 0;

          const isWinner = winner?.team_name === team.team_name;

          return (
            <motion.div
              key={team.team_name}
              initial={{ opacity: 0, y: 80 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              whileHover={{ scale: 1.04, y: -10 }}
              className="relative rounded-[40px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.35)] border-4 border-gray-300 bg-white z-20"
            >
              {/* WINNER NEON GLOW */}
              {isWinner && (
                <div className="absolute -inset-10 bg-gray-400 blur-[140px] opacity-40 animate-pulse z-0" />
              )}

              {/* IMAGE AREA */}
              <div className="relative h-[600px] w-full z-10">
                <img src={team.image} className="w-full h-full object-cover" />

                {/* DARK GRADIENT */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

                {/* WINNER PULSE BORDER */}
                {/* {isWinner && (
                  <motion.div
                    animate={{ opacity: [0.3, 0.8, 0.3] }}
                    transition={{ repeat: Infinity, duration: 2 }}
                    className="absolute inset-0 border-[6px] border-green-400 rounded-[40px]"
                  />
                )} */}

                {/* CROWN */}
                {isWinner && (
                  <div className="absolute top-6 right-6 text-7xl animate-bounce">
                    👑
                  </div>
                )}

                {/* TARGET HIT */}
                {pct >= 100 && (
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    className="absolute top-6 left-6 bg-green-500 text-white px-6 py-3 rounded-full font-black text-xl shadow-lg"
                  >
                    🎯 TARGET HIT
                  </motion.div>
                )}

                {/* TEAM NAME */}
                <div className="absolute bottom-8 left-8">
                  <h2 className="text-6xl font-black text-white drop-shadow-2xl">
                    {team.team_name}
                  </h2>
                </div>
              </div>

              {/* STATS AREA */}
              <div className="bg-white/95 backdrop-blur-xl p-8">
                <div className="grid grid-cols-3 items-center text-center">
                  {/* Orders */}
                  <div>
                    <p className="text-gray-500 text-lg">Orders</p>
                    <p className="text-5xl font-black text-indigo-600">
                      {team.orders}
                    </p>
                  </div>

                  {/* Target */}
                  <div>
                    <p className="text-gray-500 text-lg">Target</p>
                    <p className="text-5xl font-black">{team.target}</p>
                  </div>

                  {/* Percentage */}
                  <div>
                    <p className="text-gray-500 text-lg">Achieved</p>
                    <p className="text-5xl font-black text-green-600">{pct}%</p>
                  </div>
                </div>

                {/* POWER BAR */}
                <div className="mt-6 relative h-7 bg-gray-800 rounded-full overflow-hidden">
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${pct}%` }}
                    transition={{ duration: 1.4 }}
                    className={`h-full ${
                      pct >= 100
                        ? "bg-gradient-to-r from-green-400 via-green-500 to-green-700"
                        : "bg-gradient-to-r from-indigo-400 via-purple-500 to-indigo-700"
                    }`}
                  />

                  <div className="absolute inset-0 flex items-center justify-center text-xs text-white font-bold">
                    POWER
                  </div>
                </div>

                {/* HOT STREAK */}
                {pct > 70 && pct < 100 && (
                  <div className="mt-4 text-center text-orange-500 text-xl font-bold animate-pulse">
                    🔥 Hot Streak
                  </div>
                )}
              </div>
            </motion.div>
          );
        })}
      </div>
    </SlideWrapper>
  );
}

function WinnerVideo({ winner }) {
  console.log("winner", winner);

  const videoRef = useRef(null);

  const videoMap = {
    GMIT: "/videos/RahulWon.mp4",
    ALTF: "/videos/AnandWon.mp4",
    DRAW: "/videos/draw.mp4",
  };

  const FloorName = {
    GMIT: "RAHUL",
    ALTF: "ANAND",
    DRAW: "BOTH",
  };

  const videoSrc = videoMap[winner];

  useEffect(() => {
    if (videoRef.current) {
      const v = videoRef.current;

      v.muted = true;
      v.defaultMuted = true;

      const playPromise = v.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          setTimeout(() => v.play(), 500);
        });
      }
    }
  }, [videoSrc]);

  if (!winner) return null;
  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-[9999]">
      <video
        ref={videoRef}
        key={videoSrc}
        src={videoSrc}
        autoPlay
        muted
        defaultMuted
        playsInline
        controls={false}
        preload="auto"
        className="w-full h-full object-cover"
      />

      <div className="absolute bottom-20 text-black text-6xl font-black">
        🏆 {FloorName[winner]} FLOOR LEADING
      </div>
    </div>
  );
}



// function WinnerVideo({ winner }) {
//   if (!winner) return null;

//   const videoMap = {
//     GMIT: "/videos/RahulWon.mp4",
//     ALTF: "/videos/AnandWon.mp4",
//     DRAW: "/videos/draw.mp4",
//   };

//   const FloorName = {
//     GMIT: "RAHUL",
//     ALTF: "ANAND",
//     DRAW: "BOTH",
//   };

//   const videoSrc = videoMap[winner];

//   return (
//     <div className="fixed inset-0 bg-black flex items-center justify-center z-[9999]">
//       <iframe width="100%" height="100%" src="/videos/anand.html" />

//       <div className="absolute bottom-20 text-white text-6xl font-black">
//         🏆 {FloorName[winner]} FLOOR LEADING
//       </div>
//     </div>
//   );
// }


function ManagerWinnerVideo({ data }) {
  const { id, battle } = data;

  const videoSrc = battle.videos[id];
  const winnerName = id === "DRAW" ? "DRAW" : battle.names[id];

  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      const v = videoRef.current;

      v.muted = true;
      v.defaultMuted = true;

      const playPromise = v.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          setTimeout(() => v.play(), 500);
        });
      }
    }
  }, [videoSrc]);

  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-[9999]">
      <video
        ref={videoRef}
        key={videoSrc}
        src={videoSrc}
        autoPlay
        muted
        defaultMuted
        playsInline
        controls={false}
        preload="auto"
        className="w-full h-full object-cover"
      />

      <div className="absolute bottom-20 text-black text-6xl font-black">
        🏆 {winnerName} LEADING THE BATTLE
      </div>
    </div>
  );
}




function RevenueSlide({ data }) {
  const format = (num) =>
    new Intl.NumberFormat("en-IN").format(Math.round(num));

  const winner =
    data.GMIT.net > data.ALTF.net ? "GMIT" : "ALTF";

  return (
    <SlideWrapper>
      <h1 className="text-6xl font-black text-center mb-10">
        💰 Monthly Revenue Battle
      </h1>

      <p className="text-center text-2xl text-gray-500 mb-6">
        (Cancelled Orders Excluded)
      </p>

      <div className="grid grid-cols-2 gap-12">
        {["GMIT", "ALTF"].map((key) => {
          const isWinner = winner === key;

          return (
            <motion.div
              key={key}
              animate={{ scale: isWinner ? [1, 1.05, 1] : 1 }}
              transition={{ repeat: isWinner ? Infinity : 0, duration: 1.5 }}
              className={`relative p-10 rounded-3xl border-4 bg-white shadow-2xl ${
                isWinner ? "border-green-500" : "border-gray-200"
              }`}
            >
              {/* HEADER */}
              <div
                className={`absolute top-0 left-0 right-0 py-3 text-center text-white font-black ${
                  isWinner ? "bg-green-600" : "bg-gray-600"
                }`}
              >
                {isWinner ? "🏆 TOP FLOOR" : "⚔️ COMPETING"}
              </div>

              {/* FLOOR NAME */}
              <h2 className="text-5xl font-black text-center mt-10">
                {key === "GMIT" ? "RAHUL" : "ANAND"}
              </h2>

              {/* NET */}
              <div className="mt-8 text-center">
                <p className="text-gray-500 text-xl">Net Revenue</p>
                <p className="text-[70px] font-extrabold text-indigo-600">
                  ₹ {format(data[key].net)}
                </p>
              </div>

              {/* PARTIAL */}
              <div className="mt-4 text-center">
                <p className="text-gray-500 text-lg">Partial</p>
                <p className="text-[45px] font-bold text-orange-500">
                  ₹ {format(data[key].partial)}
                </p>
              </div>

              {/* TOTAL */}
              <div className="mt-6 bg-gray-100 rounded-xl py-4 text-center">
                <p className="text-gray-600">Total</p>
                <p className="text-4xl font-black text-green-600">
                  ₹ {format(data[key].net + data[key].partial)}
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </SlideWrapper>
  );
}



// function RevenueSlidePro({ data }) {
//   const format = (num) =>
//     new Intl.NumberFormat("en-IN").format(Math.round(num));

//   const { floor, topManager, cancelledLoss, AOV } = data;

//   const winner =
//     floor.GMIT.net > floor.ALTF.net ? "GMIT" : "ALTF";

//   const totalGMIT = floor.GMIT.net + floor.GMIT.partial;
//   const totalALTF = floor.ALTF.net + floor.ALTF.partial;

//   const growthDiff = Math.abs(totalGMIT - totalALTF);

//   return (
//     <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white p-10 rounded-3xl">

//       {/* ===== HEADER ===== */}
//       <div className="text-center mb-10">
//         <h1 className="text-6xl font-extrabold mb-2">
//           💰 Revenue Intelligence
//         </h1>

//         <p className="text-xl text-gray-300">
//           Rahul vs Anand • April 2026
//         </p>
//       </div>

//       {/* ===== KPI CARDS ===== */}
//       <div className="grid grid-cols-3 gap-6 mb-12">
        
//         {/* AOV */}
//         <div className="bg-white/10 backdrop-blur-lg p-6 rounded-2xl text-center shadow-xl">
//           <p className="text-gray-300">Average Order Value</p>
//           <p className="text-4xl font-bold text-green-400">
//             ₹ {format(AOV)}
//           </p>
//         </div>

//         {/* LOSS */}
//         <div className="bg-white/10 backdrop-blur-lg p-6 rounded-2xl text-center shadow-xl">
//           <p className="text-gray-300">Cancelled Loss</p>
//           <p className="text-4xl font-bold text-red-400">
//             ₹ {format(cancelledLoss)}
//           </p>
//         </div>

//         {/* TOP MANAGER */}
//         <div className="bg-white/10 backdrop-blur-lg p-6 rounded-2xl text-center shadow-xl">
//           <p className="text-gray-300">Top Performer</p>

//           <div className="flex flex-col items-center mt-2">
//             <img
//               src={`https://ui-avatars.com/api/?name=${topManager.name}`}
//               className="w-16 h-16 rounded-full mb-2"
//             />
//             <p className="text-xl font-bold text-indigo-400">
//               👑 {topManager.name}
//             </p>
//             <p className="text-sm text-gray-300">
//               ₹ {format(topManager.net)}
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* ===== FLOOR COMPARISON ===== */}
//       <div className="grid grid-cols-2 gap-10">

//         {/* GMIT */}
//         <motion.div
//           animate={{
//             scale: winner === "GMIT" ? [1, 1.05, 1] : 1,
//           }}
//           transition={{ duration: 1.2, repeat: Infinity }}
//           className={`p-8 rounded-3xl shadow-2xl ${
//             winner === "GMIT"
//               ? "bg-gradient-to-br from-green-600 to-green-400"
//               : "bg-white/10"
//           }`}
//         >
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-3xl font-black">RAHUL (GMIT)</h2>
//             <img
//               src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
//               className="w-14"
//             />
//           </div>

//           <p className="text-gray-200">Net Revenue</p>
//           <p className="text-5xl font-extrabold">
//             ₹ {format(floor.GMIT.net)}
//           </p>

//           <p className="mt-3 text-gray-200">Partial</p>
//           <p className="text-2xl font-bold text-yellow-200">
//             ₹ {format(floor.GMIT.partial)}
//           </p>

//           <div className="mt-4 border-t pt-3">
//             <p className="text-lg font-semibold">
//               Total: ₹ {format(totalGMIT)}
//             </p>
//           </div>
//         </motion.div>

//         {/* ALTF */}
//         <motion.div
//           animate={{
//             scale: winner === "ALTF" ? [1, 1.05, 1] : 1,
//           }}
//           transition={{ duration: 1.2, repeat: Infinity }}
//           className={`p-8 rounded-3xl shadow-2xl ${
//             winner === "ALTF"
//               ? "bg-gradient-to-br from-indigo-600 to-indigo-400"
//               : "bg-white/10"
//           }`}
//         >
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-3xl font-black">ANAND (ALTF)</h2>
//             <img
//               src="https://cdn-icons-png.flaticon.com/512/4140/4140048.png"
//               className="w-14"
//             />
//           </div>

//           <p className="text-gray-200">Net Revenue</p>
//           <p className="text-5xl font-extrabold">
//             ₹ {format(floor.ALTF.net)}
//           </p>

//           <p className="mt-3 text-gray-200">Partial</p>
//           <p className="text-2xl font-bold text-yellow-200">
//             ₹ {format(floor.ALTF.partial)}
//           </p>

//           <div className="mt-4 border-t pt-3">
//             <p className="text-lg font-semibold">
//               Total: ₹ {format(totalALTF)}
//             </p>
//           </div>
//         </motion.div>
//       </div>

//       {/* ===== INSIGHT FOOTER ===== */}
//       <div className="mt-12 text-center">
//         <p className="text-lg text-gray-300">
//           📊 Performance Gap:
//         </p>

//         <p className="text-3xl font-bold text-yellow-400">
//           ₹ {format(growthDiff)}
//         </p>

//         <p className="text-gray-400 mt-2">
//           {winner} is leading this month 🚀
//         </p>
//       </div>
//     </div>
//   );
// }


function RevenueSlidePro({ data }) {
  const containerRef = useRef();

  const format = (num) =>
    new Intl.NumberFormat("en-IN").format(Math.round(num));

  const { floor, topManager, cancelledLoss, AOV } = data;

  const winner =
    floor.GMIT.net > floor.ALTF.net ? "GMIT" : "ALTF";

  const totalGMIT = floor.GMIT.net + floor.GMIT.partial;
  const totalALTF = floor.ALTF.net + floor.ALTF.partial;

  const growthDiff = Math.abs(totalGMIT - totalALTF);

  const total = totalGMIT + totalALTF;
  const GMITPercent = ((totalGMIT / total) * 100).toFixed(1);
  const ALTFPercent = ((totalALTF / total) * 100).toFixed(1);

  // ===== GSAP =====
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".fade-up", {
        y: 50,
        opacity: 0,
        duration: 0.9,
        stagger: 0.15,
        ease: "power3.out",
      });

      gsap.from(".card", {
        y: 20,
        opacity: 0,
        duration: 0.6,
        stagger: 0.1,
        delay: 0.3,
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div
      ref={containerRef}
      className="bg-gradient-to-br from-[#f8fafc] to-[#eef2ff] min-h-screen p-10 rounded-3xl"
    >
      {/* ===== HEADER ===== */}
      <div className="text-center mb-14 fade-up border border-gray-300 rounded-xl p-6 bg-white shadow">
        <h1 className="text-6xl font-extrabold text-gray-900 tracking-tight">
          💰 Revenue Intelligence
        </h1>

        <p className="text-lg text-gray-500 mt-3">
          Rahul vs Anand • April 2026
        </p>
      </div>

      {/* ===== KPI CARDS ===== */}
      <div className="grid grid-cols-3 gap-6 mb-16">
        {/* AOV */}
        <div className="card bg-white/70 backdrop-blur-xl p-6 rounded-2xl shadow-lg border">
          <p className="text-gray-500">Average Order Value</p>
          <p className="text-4xl font-bold text-green-600 mt-2">
            ₹ {format(AOV)}
          </p>
        </div>

        {/* LOSS */}
        <div className="card bg-white/70 backdrop-blur-xl p-6 rounded-2xl shadow-lg border">
          <p className="text-gray-500">Cancelled Loss</p>
          <p className="text-4xl font-bold text-red-500 mt-2">
            ₹ {format(cancelledLoss)}
          </p>
        </div>

        {/* TOP MANAGER */}
        <div className="card bg-white/70 backdrop-blur-xl p-6 rounded-2xl shadow-lg border text-center">
          <p className="text-gray-500">Top Performer</p>

          <img
            src={`https://ui-avatars.com/api/?name=${topManager.name}`}
            className="w-16 h-16 rounded-full mx-auto mt-3 shadow"
          />

          <p className="text-lg font-bold text-indigo-600 mt-2">
            👑 {topManager.name}
          </p>

          <p className="text-gray-500">
            ₹ {format(topManager.net)}
          </p>
        </div>
      </div>

      {/* ===== FLOOR CARDS ===== */}
      <div className="grid grid-cols-2 gap-10 mb-16">
        {/* GMIT */}
        <motion.div
          whileHover={{ scale: 1.03 }}
          className={`card p-8 rounded-3xl bg-white shadow-xl border ${
            winner === "GMIT"
              ? "border-green-400"
              : "border-gray-200"
          }`}
        >
          <h2 className="text-2xl font-bold text-gray-800 mb-3">
            RAHUL (GMIT)
          </h2>

          <p className="text-gray-500">Net</p>
          <p className="text-4xl font-extrabold text-indigo-600">
            ₹ {format(floor.GMIT.net)}
          </p>

          <p className="text-gray-500 mt-3">Partial</p>
          <p className="text-xl font-semibold text-orange-500">
            ₹ {format(floor.GMIT.partial)}
          </p>

          <div className="mt-4 border-t pt-3">
            <p className="font-bold text-gray-800">
              Total: ₹ {format(totalGMIT)}
            </p>
          </div>

          {/* Progress */}
          <div className="mt-4">
            <div className="h-3 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-green-500"
                style={{ width: `${GMITPercent}%` }}
              />
            </div>
            <p className="text-sm text-gray-500 mt-1">
              {GMITPercent}% Contribution
            </p>
          </div>
        </motion.div>

        {/* ALTF */}
        <motion.div
          whileHover={{ scale: 1.03 }}
          className={`card p-8 rounded-3xl bg-white shadow-xl border ${
            winner === "ALTF"
              ? "border-indigo-400"
              : "border-gray-200"
          }`}
        >
          <h2 className="text-2xl font-bold text-gray-800 mb-3">
            ANAND (ALTF)
          </h2>

          <p className="text-gray-500">Net</p>
          <p className="text-4xl font-extrabold text-indigo-600">
            ₹ {format(floor.ALTF.net)}
          </p>

          <p className="text-gray-500 mt-3">Partial</p>
          <p className="text-xl font-semibold text-orange-500">
            ₹ {format(floor.ALTF.partial)}
          </p>

          <div className="mt-4 border-t pt-3">
            <p className="font-bold text-gray-800">
              Total: ₹ {format(totalALTF)}
            </p>
          </div>

          {/* Progress */}
          <div className="mt-4">
            <div className="h-3 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-indigo-500"
                style={{ width: `${ALTFPercent}%` }}
              />
            </div>
            <p className="text-sm text-gray-500 mt-1">
              {ALTFPercent}% Contribution
            </p>
          </div>
        </motion.div>
      </div>

      {/* ===== FINAL INSIGHT ===== */}
      <div className="fade-up text-center">
        <p className="text-gray-500 text-lg">
          📊 Performance Gap
        </p>

        <p className="text-5xl font-bold text-yellow-500">
          ₹ {format(growthDiff)}
        </p>

        <p className="mt-3 text-lg text-gray-600">
          <span className="font-bold text-indigo-600">
            {winner}
          </span>{" "}
          is leading with stronger revenue efficiency 🚀
        </p>
      </div>
    </div>
  );
}




// function RevenueSlidePro({ data }) {
//   const format = (num) =>
//     new Intl.NumberFormat("en-IN").format(Math.round(num));

//   const { floor, topManager, cancelledLoss, AOV } = data;

//   const winner =
//     floor.GMIT.net > floor.ALTF.net ? "GMIT" : "ALTF";

//   return (
//     <SlideWrapper>
//       {/* ===== HEADER ===== */}
//       <h1 className="text-6xl font-black text-center mb-6">
//         💰 Revenue Intelligence Dashboard
//       </h1>
// <h2 className="text-3xl font-bold text-center mb-6">
//           {`Comparing Rahul and Anand's Revenue Performance (Cancelled Orders Excluded)`}
//         </h2>

//         <p className="text-xl text-gray-600">April 2026</p>
//       {/* ===== TOP STATS BAR ===== */}
//       <div className="grid grid-cols-3 gap-6 mb-8">
//         <div className="bg-green-100 p-6 rounded-xl text-center">
//           <p className="text-gray-600">AOV</p>
//           <p className="text-4xl font-black text-green-700">
//             ₹ {format(AOV)}
//           </p>
//         </div>

//         <div className="bg-red-100 p-6 rounded-xl text-center">
//           <p className="text-gray-600">Cancelled Loss</p>
//           <p className="text-4xl font-black text-red-700">
//             ₹ {format(cancelledLoss)}
//           </p>
//         </div>

//         <div className="bg-indigo-100 p-6 rounded-xl text-center">
//           <p className="text-gray-600">Top Performer</p>
//           <p className="text-2xl font-black text-indigo-700">
//             👑 {topManager.name}
//           </p>
//           <p className="text-xl text-gray-700">
//             ₹ {format(topManager.net)}
//           </p>
//         </div>
//       </div>

//       {/* ===== FLOOR BATTLE ===== */}
//       <div className="grid grid-cols-2 gap-12">
//         {["GMIT", "ALTF"].map((key) => {
//           const isWinner = winner === key;

//           return (
//             <motion.div
//               key={key}
//               animate={{ scale: isWinner ? [1, 1.05, 1] : 1 }}
//               transition={{ repeat: isWinner ? Infinity : 0, duration: 1.4 }}
//               className={`p-8 rounded-3xl border-4 ${
//                 isWinner ? "border-green-500" : "border-gray-200"
//               }`}
//             >
//               <h2 className="text-4xl font-black text-center mb-4">
//                 {key === "GMIT" ? "RAHUL" : "ANAND"}
//               </h2>

//               <p className="text-center text-gray-500">Net</p>
//               <p className="text-5xl font-black text-indigo-600 text-center">
//                 ₹ {format(floor[key].net)}
//               </p>

//               <p className="text-center text-gray-500 mt-2">Partial</p>
//               <p className="text-3xl font-bold text-orange-500 text-center">
//                 ₹ {format(floor[key].partial)}
//               </p>

//               <p className="text-center mt-4 text-green-600 font-bold">
//                 Total: ₹ {format(floor[key].net + floor[key].partial)}
//               </p>
//             </motion.div>
//           );
//         })}
//       </div>
//     </SlideWrapper>
//   );
// }